"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _upTimeliness = require("up-timeliness");

var _upTimeliness2 = _interopRequireDefault(_upTimeliness);

var _cUrl = require("c-url");

var _cUrl2 = _interopRequireDefault(_cUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Timeliness from "./Timeliness";
/**
 * pbajax模块(用于pb接口交互)
 * @author zhenn
 * @time 2016-11-16
 */
var proxyUrl = {
  pro: "https://proxy.upliveapps.com/index/index",
  dev: "http://awsbj-proxy.pengpengla.com/index/index",
  stage: "https://up-b-go-proxy.pengpengla.com/index/index"
};
var env = _cUrl2.default.query("env");
function getSiteKey() {
  return env != "stage" ? "6LehykohAAAAAMpbs7zayi9a1ARwcBGeSOjrxkyK" : "6LfyGWwhAAAAANlDGQDAe0rTtJqeOslAksefVacB";
}

var PbAajx = function () {
  function PbAajx(props) {
    (0, _classCallCheck3.default)(this, PbAajx);

    var _ref = props || {},
        siteKey = _ref.siteKey;

    this.siteKey = siteKey || getSiteKey();
    this.canceled = 0;
  }

  (0, _createClass3.default)(PbAajx, [{
    key: "getPayload",
    value: function getPayload(cfg) {
      return (0, _upTimeliness2.default)({ pbajax: this, siteKey: this.siteKey, action: cfg.api }).then(function (res) {
        var payload = res.payload;

        return payload;
      }).catch(function (err) {
        return "";
      });
    }
    // canceled: 0, // 是否被取消

  }, {
    key: "do",
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(cfg, data) {
        var success = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

        var _this = this;

        var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
        var fail = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};

        var prefix, payload, _url, timer, xhr;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                prefix = proxyUrl[this.env()] || "pro";

                cfg.header = cfg.header || {};

                if (!(!cfg.header.payload && !cfg.isPayload)) {
                  _context.next = 7;
                  break;
                }

                _context.next = 5;
                return this.getPayload(cfg);

              case 5:
                payload = _context.sent;

                // cfg.header.payload = payload;

              case 7:
                delete cfg.isPayload;
                _url = prefix + "?" + $.param(cfg);
                timer = void 0, xhr = void 0;

                timer = setTimeout(function () {
                  timeout();
                }, 10000);

                try {
                  xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
                  xhr.open("POST", _url, true);
                  xhr.responseType = "arraybuffer";

                  try {
                    xhr.send(data.toArrayBuffer());
                  } catch (e) {
                    xhr.send();
                  }
                } catch (e) {
                  alert("please upgrade your brower, such as chrome!");
                }

                xhr.onreadystatechange = function (data) {
                  if (xhr.readyState == 4) {
                    if (xhr.status == 200) {
                      clearTimeout(timer);
                      if (!_this.canceled) {
                        success(xhr.response);
                      }
                    } else {
                      if (typeof fail == "function") {
                        fail();
                      }
                    }
                  }
                };

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _do(_x, _x2) {
        return _ref2.apply(this, arguments);
      }

      return _do;
    }()
  }, {
    key: "query",
    value: function query(name, scope) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
          scope = scope || "search",
          r = location[scope].substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    }
  }, {
    key: "env",
    value: function env() {
      return this.query("env") || "pro";
    }
  }, {
    key: "serializeURI",
    value: function serializeURI(obj) {
      var result = [];
      if ((typeof obj === "undefined" ? "undefined" : (0, _typeof3.default)(obj)) != "object") {
        obj = {};
      }
      for (var i in obj) {
        result.push(i + "=" + encodeURIComponent(obj[i]));
      }

      return result.join("&");
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.canceled = 1;
    }
  }]);
  return PbAajx;
}();

exports.default = PbAajx;


//////////////////
// WEBPACK FOOTER
// ./node_modules/up-pbajax/dist/index.js
// module id = 40
// module chunks = 0 1